export const MSInvsLight = {
  colors: {
    statusBar:"dark",
    main: "#6CA7CF",
    mainTransparency: "#6CA7CF78",
    textColor: "black",
    textInputBackground: "#F0F9FF",
    background: "white",
    shadowColor: "black",
    error: "#B73131",
    errorLight: "#fee7e7",
    upvote: "rgb(14,204,86)",
    upvoteLight: "#0ecc565c",
    downvote: "#e66363",
    downvoteLight: "#e663635c",
    countableDivider: "#FFBABA",
    buttonTextColor: "white",
    buttonDisabled: "#6CA7CF1E",
    itemContainer: "#F0F9FF",
    itemDataHeader: "#b3b6b8",
  },
};

export const MSInvsDark = {
  colors: {
    statusBar:"light",
    main: "#6CA7CF",
    mainTransparency: "#6CA7CF78",
    textColor: "white",
    textInputBackground: "rgb(29,39,45)",
    background: "#121a1e",
    shadowColor: "black",
    error: "#CF6C6C",
    errorLight: "rgb(45,29,29)",
    upvote: "rgb(14,204,86)",
    upvoteLight: "#0ecc565c",
    downvote: "#e66363",
    downvoteLight: "#e663635c",
    countableDivider: "#FFBABA",
    buttonTextColor: "#121a1e",
    buttonDisabled: "#6CA7CF1E",
    itemContainer: "rgb(29,39,45)",
    itemDataHeader: "#b3b6b8",
  },
};
